import React from 'react';
import Loader from '../components/pages/Loader';
import {usePage} from '../api/hooks';
import Error from '../components/pages/Error';
import DefaultHeader from '../components/pages/head/DefaultHeader';
import config from '../config/config';
import PageNotFound from '../components/pages/PageNotFound';
import {MatomoListener} from '../config/matomo';

const SiteLoader = ({match: {params: {path}}}) => {
    const {data: page, isLoading, error} = usePage(path);

    if (isLoading) {
        return (
            <Loader />
        );
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    if (Object.keys(page).length === 0) {
        return <PageNotFound />;
    }

    const {content, title} = page;

    return (
        <MatomoListener>
            {() => (
                <>
                    <DefaultHeader image={config.images.pages.api} title={title} />

                    <section className="section-padding-1_7 border-bottom">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div dangerouslySetInnerHTML={{__html: content}} />
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </MatomoListener>

    );
};

export default SiteLoader;
